import { Directive, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { throwError } from 'rxjs';
import { LogService } from '../services/log.service';
import { SecurityService } from '../services/security.service';
import { VisualsService } from '../services/visuals.service';

@Directive()
export class BaseCRUDComponent<T extends SecurityService> implements OnInit {
  public visuals: any = {};
  public genericVisuals: any = {};
  public urlParams: any = {};
  public bean: any = {};
  public loading: boolean = false;
  protected submiting: boolean = false;
  protected editForm: UntypedFormGroup;
  protected validationMessages = {};
  protected getValidationMessages(): void {}

  // protected dateRegex = /(^(((0[1-9]|[12][0-8])[\/](0[1-9]|1[012]))|((29|30|31)[\/](0[13578]|1[02]))|((29|30)[\/](0[4,6,9]|11)))[\/](19|[2-9][0-9])\d\d$)|(^29[\/]02[\/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;
  protected dateRegex =
    /(^(((0[1-9]|1[0-9]|2[0-8])[\/](0[1-9]|1[012]))|((29|30|31)[\/](0[13578]|1[02]))|((29|30)[\/](0[4,6,9]|11)))[\/](19|[2-9][0-9])\d\d$)|(^29[\/]02[\/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;
  protected intRegex = /(^0$)|(^[1-9]\d*$)/;
  protected decimalRegex = /^[0-9]+(\.[0-9]{1,2})?$/;
  protected mailRegex = /^[a-zA-Z0-9._-]+[@]+[a-zA-Z0-9-]+[.]+[a-zA-Z]{2,6}/;

  //Used to show user's choice on confirmation modal
  protected requestActionMsg: any = {};
  protected confirmationMsg = '';
  protected confirmationLoader = false;
  protected confirmationFlag = '';

  constructor(
    protected logger: LogService,
    protected visualsService: VisualsService,
    protected route: ActivatedRoute,
    protected fb: UntypedFormBuilder,
    protected router: Router,
    protected group: string,
  ) {}

  ngOnInit(): void {
    this.loadVisuals();
    this.fillView();
    this.initLoadBean();
  }

  protected fillView() {}

  protected loadVisuals(): void {
    this.getGenericVisuals();
    this.getVisuals();
  }

  protected getVisuals() {
    this.visuals = this.visualsService.getFromStorageAsJSON('visualsArray')[this.group];
    this.getValidationMessages();
  }

  protected getGenericVisuals() {
    this.genericVisuals = this.visualsService.getFromStorageAsJSON('visualsArray')['generic'];
  }

  protected loadBean(map: Map<string, any>): any {}

  protected save(bean: any) {}

  protected initLoadBean() {
    this.urlParams = {};

    this.route.params.subscribe({
      next: (params) => {
        this.logger.warn(params);
        this.urlParams = params;
        if (this.loadBean(this.urlParams) != null) {
          this.loading = true;
        }
        (error) => {
          return throwError(() => new Error(error));
        };
      },
    });
  }
}
